import { AuthService } from "./../../../../../apps/resource-portal/src/app/services/auth.service";
import {
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpParams,
  HttpParameterCodec,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { StorageService } from "../services/storage.service";
import {
  Observable,
  throwError as observableThrowError,
  throwError,
} from "rxjs";
import { tap, catchError, finalize } from "rxjs/operators";
import { Router } from "@angular/router";
import { DialogService } from "./dialog.service";
import { HttpMonitor } from "../utils/http.monitor";
@Injectable({
  providedIn: "root",
})
export class AuthInterceptorService implements HttpInterceptor {
  constructor(
    public storageService: StorageService,
    private router: Router,
    private _dialogService: DialogService,
    private _authService: AuthService,
    private httpMonitor: HttpMonitor
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.storageService.getStorageItem("token");
    const url = req.url;

    const params = new HttpParams({
      encoder: new CustomEncoder(),
      fromString: req.params.toString(),
    });

    let headers: HttpHeaders = req.headers.set(
      "abc",
      "FIYh43rMVhzUpCN2/pVq38C4DQHyuJ6zr0ZD0GF64eS/hSSzGCKMjA=="
    );

    let cloned = req.clone({
      params,
      headers,
    });

    if (token) {
      cloned = req.clone({
        headers: headers.set("token", `${token}`),
        params,
      });
    }

    if (req.headers.get("loader") != "false") {
      this.httpMonitor.addRequest();
    }

    //
    return next.handle(cloned).pipe(
      tap((res) => {
        if (res instanceof HttpResponse) {
        }
      }),
      finalize(() => {
        //
        if (req.headers.get("loader") != "false") {
          this.httpMonitor.removeRequest();
        }
      }),
      catchError((err: HttpErrorResponse) => {
        if (err instanceof HttpErrorResponse) {
          switch (err.status) {
            case 400:
              if (err && err.error && err.message) {
                this._dialogService.showToast(
                  err.error.message,
                  "snackbar-error"
                );
              } else {
                //this._dialogService.showToast('Internal Server Error', 'snackbar-error');
              }
              break;
            case 401:
              if (err && err.error && err.message) {
                this._dialogService.showToast(
                  err.error.message,
                  "snackbar-error"
                );
              } else {
                //this._dialogService.showToast('Internal Server Error', 'snackbar-error');
              }
              this.logout(true);
              break;
            case 404:
              if (err && err.error && err.message) {
                this._dialogService.showToast(
                  err.error.message,
                  "snackbar-error"
                );
              } else {
                //this._dialogService.showToast('Internal Server Error', 'snackbar-error');
              }
              break;
            case 409:
              if (err && err.error && err.message) {
                this._dialogService.showToast(
                  err.error.message,
                  "snackbar-error"
                );
              } else {
                //this._dialogService.showToast('Internal Server Error', 'snackbar-error');
              }
              break;
            case 422:
              if (err && err.error && err.message) {
                this._dialogService.showToast(
                  err.error.message,
                  "snackbar-error"
                );
              } else {
                //this._dialogService.showToast('Internal Server Error', 'snackbar-error');
              }
              break;
            case 500:
              if (err && err.error && err.message) {
                // this._dialogService.showToast(err.error.message, 'snackbar-error');
              } else {
                //this._dialogService.showToast('Internal Server Error', 'snackbar-error');
              }
              break;
            case 0:
              //this._dialogService.showToast("Server Error", 'snackbar-error');
              break;
            default:
              return observableThrowError(err);
          }
          //
        }
        // this.router.navigate(['/']);
        return throwError(err);
      })
    );
  }

  logout(sessionExpiry?: boolean) {
    this.storageService.clearAll();
    this._authService.isLoggedIn.next(false);
    this._authService.$user.next(null);
    if (sessionExpiry) this.router.navigate(["/login"]);
    else this.router.navigate(["/401"]);
  }
}

class CustomEncoder implements HttpParameterCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }

  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }

  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }

  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}
